import axios from "axios";
import { getUrlForActivityDayHours } from "utils/endpointUtils/activitiesEndpointUtil";
import { setAuthHeader } from "app/services/auth.header.service";

/**
 * Hours already saved per day for one owner, as a { "yyyy-MM-dd": hours } map.
 *
 * Resolves to an empty map on any failure. These figures are a hint that helps the user avoid a
 * 24-hour rejection, and the server enforces the rule regardless — so a flaky read must never block
 * someone from logging their timesheet.
 *
 * @since NEXT_VERSION
 */
export const loadDayHoursForOwner = async (ownerId, isMember, fromDate, toDate) => {
  if (ownerId === null || ownerId === undefined) return {};

  try {
    // Inside the try: resolving the auth header can throw too, and the contract above promises a
    // map rather than an exception — these figures are a hint, never a gate.
    const config = setAuthHeader();
    if (config === null) return {};

    const response = await axios.get(
      getUrlForActivityDayHours(ownerId, isMember, fromDate, toDate),
      config
    );
    const rows = Array.isArray(response?.data) ? response.data : [];
    return rows.reduce((acc, row) => {
      if (row?.date) acc[row.date] = Number(row.hours) || 0;
      return acc;
    }, {});
  } catch (error) {
    return {};
  }
};
